import {registerTileSchema} from '#core/application/schema-registry.js';

import MINI_SCOREBOARD from './mini-scoreboard.palette-schema.yaml';

registerTileSchema(MINI_SCOREBOARD);

export function generateMiniScoreboard(TILE) {
    return {
        scoresTextMain: {
            ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
        },
        scoresTextSecondary: {
            ...TILE.MINI_SCOREBOARD_SCORES_TEXT,
        },
        scoresColumn: {
            ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
        },
        segmentIndicators: {
            top: '-16px',
            text: {
                ...TILE.MINI_SCOREBOARD_SEGMENT_INDICATOR_TEXT,
            },
        },
        serverIndicator: {
            color: TILE.MINI_SCOREBOARD_SERVER_INDICATOR,
            width: '4px',
            _mobile_width: '6px',
        },
        scoreColumn: {
            margin: '0px 0px 0px 8px',
            minWidth: '8px',
        },
        scoreCount: {
            style: {
                scoreText: {
                    ...TILE.MINI_SCOREBOARD_SCORE_COUNT_TEXT,
                },
            },
        },
    };
}
